@if (type === "arcgis-webmap") {
  <ng-container *ngTemplateOutlet="arcgisWebmap"></ng-container>
}

@if (type === "search-results") {
  <ng-container *ngTemplateOutlet="searchResultsLeft"></ng-container>
}

@if (type === "search-results-webmap") {
  <div class="search-result-skeleton">
    <ng-container *ngTemplateOutlet="searchResultsLeft"></ng-container>
    <div class="right-section-skeletion">
      <ng-container *ngTemplateOutlet="arcgisWebmap"></ng-container>
    </div>
  </div>
}

@if (type === "cdfi-list") {
  <ng-container *ngTemplateOutlet="cdfiList"></ng-container>
}

@if (type === "business-profiles") {
  <ng-container *ngTemplateOutlet="businessProfiles"></ng-container>
}

@if (type === "sme-dashboard") {
  <ng-container *ngTemplateOutlet="smeDashboard"></ng-container>
}

@if (type === "achievements") {
  <ng-container *ngTemplateOutlet="achievementsSkeleton"></ng-container>
}

<ng-template #arcgisWebmap>
  <div class="skeleton-box"></div>
</ng-template>

<ng-template #searchResultsLeft>
  <div class="left-section-skeleton">
    <div class="skeleton-header">
      <div class="skeleton-checkbox"></div>
    </div>

    <div class="skeleton-body">
      @for (item of [1, 2, 3]; track item) {
        <div class="skeleton-row">
          <div class="skeleton-checkbox"></div>

          <div class="skeleton-content">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #cdfiList>
  <div class="list-wrapper">
    @for (item of [1, 2, 3, 4]; track item) {
      <div class="skeleton-cdfi-card">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-title"></div>
          <div class="skeleton-line skeleton-desc"></div>
          <div class="skeleton-tags">
            <div class="skeleton-tag"></div>
            <div class="skeleton-tag"></div>
          </div>
        </div>
        <div class="skeleton-arrow"></div>
      </div>
    }
  </div>
</ng-template>

<ng-template #businessProfiles>
  <div class="business-profiles-skeleton">
    <!-- Basic Information Section Skeleton -->
    <div class="skeleton-section-header">
      <div class="skeleton-title-line"></div>
    </div>

    <!-- Application Summary Skeleton -->
    <div class="skeleton-summary-container">
      <div class="skeleton-label-line"></div>
      <div class="skeleton-paragraph">
        <div class="skeleton-text-line"></div>
        <div class="skeleton-text-line"></div>
        <div class="skeleton-text-line short"></div>
      </div>
    </div>

    <!-- Basic Info Grid Skeleton -->
    <div class="skeleton-basic-info-grid">
      @for (item of [1, 2, 3, 4, 5, 6]; track item) {
        <div class="skeleton-info-item">
          <div class="skeleton-label-line"></div>
          <div class="skeleton-value-line"></div>
        </div>
      }
    </div>

    <!-- Products & Services Section Skeleton -->
    <div class="skeleton-section-header spacing">
      <div class="skeleton-title-line"></div>
    </div>
    <div class="skeleton-products-grid">
      @for (item of [1, 2, 3]; track item) {
        <div class="skeleton-product-card">
          <div class="skeleton-product-icon"></div>
          <div class="skeleton-product-content">
            <div class="skeleton-product-title"></div>
            <div class="skeleton-product-desc"></div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #smeDashboard>
  <div class="sme-dashboard-skeleton">
    <!-- CTA Container -->
    <div class="skeleton-cta">
      <div class="skeleton-cta-content">
        <div class="skeleton-badge"></div>
        <div class="skeleton-line skeleton-cta-title"></div>
        <div class="skeleton-line skeleton-cta-desc"></div>
        <div class="skeleton-line skeleton-cta-desc short"></div>
      </div>
      <div class="skeleton-cta-button"></div>
    </div>

    <!-- Metrics Grid -->
    <div class="skeleton-metrics-grid">
      @for (item of [1, 2, 3, 4]; track item) {
        <div class="skeleton-metric-card">
          <div class="skeleton-metric-icon"></div>
          <div class="skeleton-metric-content">
            <div class="skeleton-line skeleton-metric-value"></div>
            <div class="skeleton-line skeleton-metric-label"></div>
          </div>
        </div>
      }
    </div>

    <!-- Engagement Container -->
    <div class="skeleton-engagement">
      <div class="skeleton-line skeleton-section-title"></div>
      <div class="skeleton-engagement-grid">
        @for (item of [1, 2]; track item) {
          <div class="skeleton-engagement-card">
            <div class="skeleton-line skeleton-card-title"></div>
            <div class="skeleton-line skeleton-card-desc"></div>
            <div class="skeleton-stat-group">
              <div class="skeleton-stat-item">
                <div class="skeleton-line skeleton-stat-label"></div>
                <div class="skeleton-line skeleton-stat-value"></div>
              </div>
              <div class="skeleton-stat-item">
                <div class="skeleton-line skeleton-stat-label"></div>
                <div class="skeleton-line skeleton-stat-value"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Setup Progress Card -->
    <div class="skeleton-setup">
      <div class="skeleton-setup-header">
        <div class="skeleton-line skeleton-section-title"></div>
        <div class="skeleton-progress-badge"></div>
      </div>
      <div class="skeleton-progress-bar"></div>
      <div class="skeleton-setup-steps">
        @for (item of [1, 2, 3]; track item) {
          <div class="skeleton-setup-step">
            <div class="skeleton-step-indicator"></div>
            <div class="skeleton-step-content">
              <div class="skeleton-line skeleton-step-title"></div>
              <div class="skeleton-line skeleton-step-desc"></div>
            </div>
            <div class="skeleton-step-button"></div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

@if (type === "signup-form") {
  <ng-container *ngTemplateOutlet="signupForm"></ng-container>
}

<ng-template #signupForm
  ><div class="signup-skeleton">
    <div class="logo-skeleton"></div>

    <div class="title-skeleton"></div>
    <div class="subtitle-skeleton"></div>

    @for (field of [1, 2, 3, 4, 5]; track field) {
      <div class="field-group">
        <div class="label-skeleton"></div>
        <div class="input-skeleton"></div>
      </div>
    }

    <div class="button-skeleton"></div>

    <div class="footer-skeleton"></div>
  </div>
</ng-template>

@if (type === "notification-table") {
  <div class="notification-skeleton">
    <div class="notification-header">
      <div class="skeleton-checkbox"></div>
      <span class="label-text">All</span>
    </div>

    <div class="notification-body">
      @for (item of [1, 2, 3]; track item) {
        <div class="notification-row">
          <div class="notification-left">
            <div class="skeleton-checkbox"></div>

            <div class="skeleton-line"></div>
          </div>

          <div class="notification-right">
            <div class="skeleton-line-small"></div>
          </div>
        </div>
      }
    </div>
  </div>
}

<ng-template #achievementsSkeleton>
  <div class="achievements-skeleton">
    <!-- Summary Card Skeleton -->
    <div class="ach-sk-summary-card">
      <div class="ach-sk-summary-row">
        <div class="ach-sk-line ach-sk-count"></div>
        <div class="ach-sk-pill"></div>
      </div>
      <div class="ach-sk-progress-track">
        <div class="ach-sk-progress-fill"></div>
      </div>
    </div>

    <!-- Recently Unlocked Chips Skeleton -->
    <div class="ach-sk-section-label"></div>
    <div class="ach-sk-chips-row">
      @for (chip of [1, 2, 3]; track chip) {
        <div class="ach-sk-chip">
          <div class="ach-sk-chip-header">
            <div class="ach-sk-tag"></div>
            <div class="ach-sk-line ach-sk-date"></div>
          </div>
          <div class="ach-sk-line ach-sk-chip-title"></div>
        </div>
      }
    </div>

    <!-- Section Cards Skeleton -->
    @for (section of [1, 2, 3]; track section) {
      <div class="ach-sk-section-card">
        <!-- Section Header -->
        <div class="ach-sk-section-header">
          <div class="ach-sk-section-info">
            <div class="ach-sk-line ach-sk-section-title"></div>
            <div class="ach-sk-line ach-sk-section-desc"></div>
          </div>
          <div class="ach-sk-section-btn"></div>
        </div>

        <!-- Badge Grid Skeleton -->
        <div class="ach-sk-badge-grid">
          @for (badge of [1, 2, 3, 4, 5, 6]; track badge) {
            <div class="ach-sk-badge-card">
              <div class="ach-sk-shield"></div>
              <div class="ach-sk-badge-lines">
                <div class="ach-sk-line ach-sk-badge-title"></div>
                <div class="ach-sk-line ach-sk-badge-sub"></div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

@if (type === "generic-table") {
  <div class="table-skeleton">
    <div class="table-header">
      <div class="skeleton skeleton-header"></div>
      <div class="skeleton skeleton-header"></div>
      <div class="skeleton skeleton-header"></div>
      <div class="skeleton skeleton-header"></div>
      <div class="skeleton skeleton-header"></div>
    </div>

    @for (item of [1, 2, 3, 4, 5]; track item) {
      <div class="table-row">
        <div class="skeleton skeleton-cell short"></div>
        <div class="skeleton skeleton-cell medium"></div>
        <div class="skeleton skeleton-cell short"></div>
        <div class="skeleton skeleton-badge"></div>
        <div class="skeleton skeleton-button"></div>
      </div>
    }
  </div>
}
